import { SupportedCountriesE } from '@/types/cyclone/models';
import { getLatamMarket } from '@/utils/latam-markets';

export {
  formatDay,
  getDatesInterval,
  getDayWithTime,
  getFormatDuration,
  getTime,
  roundToNearestFiveMinutes
} from './schedule';

export { flatten } from './array';

// normalizePhone NO se re-exporta acá: `./phone` importa libphonenumber-js
// (~117KB, vendor-phone). Como este barrel `@/utils` es eager (lo importa Row →
// components barrel → index.tsx), re-exportarlo arrastraba libphonenumber al
// bundle eager aunque nadie eager use normalizePhone. Importar por path:
//   import { normalizePhone } from '@/utils/phone';
export const getNewId = (): number => Date.now() + Math.random();

export const blobToBase64 = async (blob: Blob): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      resolve(reader.result);
    };
  });
};
export const urlImageToFile = async (url: string) => {
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = {
    type: 'image/jpeg'
  };
  const file = new File([data], 'image.jpg', metadata);
  return file;
};

export const omit = (obj: any, ...keys: any) => {
  const keysToRemove = new Set(keys.flat()); // flatten the props, and convert to a Set

  return Object.fromEntries(
    // convert the entries back to object
    Object.entries(obj) // convert the object to entries
      .filter(([k]) => !keysToRemove.has(k)) // remove entries with keys that exist in the Set
  );
};

export const getBase64FromUrl = async (url: string): Promise<string> => {
  const data = await fetch(url);
  if (!data.ok) throw new Error(`No pudimos leer la imagen (HTTP ${data.status})`);
  const blob = await data.blob();

  // FileReader no existe en algunos webviews ni en Safari con Lockdown Mode: el
  // `new FileReader()` tiraba "Can't find variable: FileReader" DENTRO del executor,
  // así que la promesa rechazaba y el llamador (fire-and-forget en un useEffect) se
  // comía el error → la imagen de /mi-pagina no se guardaba y nadie se enteraba.
  if (typeof FileReader === 'undefined') {
    throw new Error('Este navegador no puede procesar imágenes (FileReader no disponible)');
  }

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    // Sin onerror/onabort la promesa NUNCA settleaba y el guardado quedaba colgado
    // para siempre. Y `onloadend` también dispara cuando la lectura falla, con
    // `result` en null: resolver ahí mandaba cover_url/avatar_url = null a la API.
    reader.onerror = () => reject(reader.error ?? new Error('No pudimos leer la imagen'));
    reader.onabort = () => reject(new Error('Lectura de la imagen cancelada'));
    reader.onloadend = () => {
      if (typeof reader.result === 'string') resolve(reader.result);
      else reject(new Error('No pudimos convertir la imagen'));
    };
    reader.readAsDataURL(blob);
  });
};

export const clearCookies = () => {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
};

export const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const isValidEmailDomain = (_value: string | undefined): boolean => true;

export const getCountryCode = (country: SupportedCountriesE): string => {
  return getLatamMarket(country)?.iso.toLowerCase() || 'ar';
};

export const escapeForSelector = (value: string): string => {
  // This replace double quotes with single quotes to avoid CSS selector issues
  // Also escape other characters that could break CSS selectors
  return value
    .replace(/"/g, "'") // Replace double quotes with single quotes
    .replace(/\\/g, '\\\\') // Escape backslashes
    .replace(/\]/g, '\\]') // Escape closing brackets
    .replace(/\[/g, '\\['); // Escape opening brackets
};
